import { render, staticRenderFns } from "./clothingInquiries.vue?vue&type=template&id=712a0418&scoped=true&"
import script from "./clothingInquiries.vue?vue&type=script&lang=js&"
export * from "./clothingInquiries.vue?vue&type=script&lang=js&"
import style0 from "./clothingInquiries.vue?vue&type=style&index=0&id=712a0418&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a0418",
  null
  
)

export default component.exports